<template>
  <v-flex xs12 ms12 md12 lg12 xl12>
    <v-card 
      min-height="100"
      color="white" 
    >
    <v-card-text>
      <v-layout row wrap justify-space-between >
        <v-flex xs6 sm3 md2 lg2 xl2>
          <v-skeleton-loader
            v-if="showImageCard() == ''"
            type="image"
            width="100"
            height="80"
          ></v-skeleton-loader>
          <v-img
            v-else
            :src="showImageCard()"
            width="100"
            height="80"
          >
          </v-img>
        </v-flex>
        <v-flex xs6 sm9 md10 lg10 xl10>
          <p>Endereço: {{ " " + immobileInfo.bairro + ' - ' + immobileInfo.cidade[1] + '/' + immobileInfo.estado[1] }}</p>
        </v-flex>
        </v-layout>
        <div class="d-flex justify-space-around pt-3">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <div v-on="on">
                  <v-icon >hotel</v-icon>
                  {{ immobileInfo.total_quartos }}
                </div>
              </template>
              <span>Total de quartos</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <div v-on="on">
                  <v-icon>hot_tub</v-icon>
                  {{ immobileInfo.total_suites }}
                </div>
              </template>
              <span>Total de suítes</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <div v-on="on">
                  <v-icon>bathtub</v-icon>
                  {{ immobileInfo.quantidade_banheiros }}
                </div>
              </template>
              <span>Total de banheiros</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <div v-on="on">
                  <v-icon>drive_eta</v-icon>
                  {{ immobileInfo.vaga_garagem_coberta + immobileInfo.vaga_garagem_descoberta }}
                </div>
              </template>
              <span>Total de garagens</span>
            </v-tooltip>
          </div>
      </v-card-text>
    </v-card>
  </v-flex>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';
import apiState from '@/ilios.store';

export default {
  name: 'ImmobileCardFavorites',

  props:{
    immobileInfo:{
      type: Object,
      required: true,
      default: null
    }
  },

  components: {
    
  },

  data: () => ({
    immobileTypes: [
      {id: 1, name: 'Casa' },
      {id: 2, name: 'Kitnet' },
      {id: 3, name: 'Sobrado' },
      {id: 4, name: 'Apartamento' },
      {id: 5, name: 'Sobreloja' },
      {id: 6, name: 'Terreno' },
      {id: 7, name: 'Sala' },
      {id: 8, name: 'Loja' },
    ],
  }),

  mounted() {
    
  },

  computed: {

  },

  watch: {

  },

  methods: {
    ...mapActions({

    }),

    ...mapGetters({
      getImmobilesImageList: 'Immobile/getImmobilesImageList'
    }),

    showImageCard(){
      var imagesList = this.getImmobilesImageList()
      var result = ''
      for (var element of imagesList){
        if(element.res_id == this.immobileInfo.id){
          result = element.url
          break
        }
      }
      return result
    },

    immobileType(typeId){
      var result = '---'
      this.immobileTypes.forEach(element => {
        if (element.id == typeId) result = element.name
      });
      return result
    },
  },
};
</script>